// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-page .btn{height:60px;width:250px;padding-top:20px}", "",{"version":3,"sources":["webpack://./public/app/pages/home/home.style.scss"],"names":[],"mappings":"AACE,gBACE,WAAA,CACA,WAAA,CACA,gBAAA","sourcesContent":[".home-page{\n  .btn{\n    height: 60px;\n    width: 250px;\n    padding-top: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
